import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { salonInfo } from '../mock';
import logo from "../assets/images/logo.jpg";


const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { name: 'Home', href: '/', isRoute: true },
    { name: 'About', href: '/#about' },
    { name: 'Franchise Enquiry', href: '/#contact' },
    { 
      name: 'Services', 
      href: '/#services',
      submenu: [
        { name: 'Haircut', href: '/haircut' },
        { name: 'Hair Colour', href: '/hair-colour' },
        { name: 'Hair Treatment', href: '/hair-treatment' },
        { name: 'Party Makeup', href: '/party-makeup' },
        { name: 'Beard Styling', href: '/beard-styling' },
        { name: 'Bridal Hair and Makeup', href: '/bridal-hair-makeup' }
      ]
    },
    { name: 'Bridal Hair and Makeup', href: '/#bridal' },
    { name: 'Store Locator', href: '/#stores' },
    { name: 'Blog', href: '/#blog' },
    { name: 'Contact', href: '/#contact' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-sm z-50 h-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img 
              src={logo}
              alt="Joker & Quinn - Unisex Luxury Salon"
              className="rounded-lg shadow-xl w-full h-[500px] object-cover imgwid"
            />
            <p className="text-xs text-gray-600 font-normal tracking-wider text-center mt-1">
              Unisex Luxury Salon
            </p>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex space-x-8">
            {navItems.map((item) => (
              <div key={item.name} className="relative group">
                <a
                  href={item.href}
                  className="c-white text-gray-700 hover:text-black font-medium transition-colors duration-200 relative"
                  onMouseEnter={() => item.submenu && setIsServicesOpen(true)}
                  onClick={(e) => {
                    e.preventDefault();
                    if (item.isRoute) {
                      navigate('/');
                      window.scrollTo(0, 0);
                    } else if (item.href.startsWith('/#')) {
                      if (location.pathname !== '/') {
                        navigate('/');
                        setTimeout(() => {
                          const id = item.href.substring(2);
                          document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
                        }, 100);
                      } else {
                        const id = item.href.substring(2);
                        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
                      }
                    }
                  }}
                >
                  {item.name}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-black group-hover:w-full transition-all duration-300"></span>
                </a>
                {item.submenu && isServicesOpen && (
                  <div 
                    className="absolute top-full left-0 mt-2 w-56 bg-white shadow-lg rounded-md py-2 z-50"
                    onMouseEnter={() => setIsServicesOpen(true)}
                    onMouseLeave={() => setTimeout(() => setIsServicesOpen(false), 200)}
                  >
                    {item.submenu.map((subItem) => (
                      <button
                        key={subItem.name}
                        onClick={() => {
                          setIsServicesOpen(false);
                          navigate(subItem.href);
                          setTimeout(() => window.scrollTo(0, 0), 0);
                        }}
                        className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-black transition-colors"
                      >
                        {subItem.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-md text-gray-700 hover:text-black hover:bg-gray-100 transition-colors"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t">
          <nav className="px-4 py-4 space-y-3">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="block text-gray-700 hover:text-black font-medium py-2 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
